import API from "../utilities/axiosConfig";

export const getGeopointsByAddress = async (searchQuery : string): Promise<any> => {
  try {
    const response = await API.get<any>(`/api/geocode/search?format=json&q=${encodeURIComponent(searchQuery)}`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching geo address:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const getAddressByGeopoints = async (lat : number, lon : number): Promise<any> => {
  try {
    const response = await API.get<any>(`/api/geocode/reverse?lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching reverse geocode:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};